import { Box, Button, Divider, Flex, Grid, GridItem, Image, Input, InputGroup, InputLeftElement, Modal, ModalContent, ModalOverlay, Popover, PopoverTrigger, Text, } from '@chakra-ui/react';
import MyDiv from './managementIntraction.style';
import { Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, DrawerCloseButton } from "@chakra-ui/react";
import { CustomPagination, CustomTable, CustomToast } from '../../../components';
import { useEffect, useRef, useState } from 'react';
import { Column } from '../../../components/CustomTable/customTable';
import { ILazyParams, useFetch } from '../../../hooks/useFetch';
import { Search2Icon } from '@chakra-ui/icons';
import FilterIcon from '../../../assets/images/Filter.svg';
import FilterPopover, { IFilterOptions } from '../../../components/FilterCard/filterCard';
import { ManagementIntractionList, ManagementMailModal, ManagementTeamDrawer, ManagementTeamMembersModal } from '../components';
import MoveTeamModal from '../components/moveTeamModal.tsx/MoveTeamModal';
import RemoveRoleDialog from '../components/RemoveRoleDialog/RemoveRoleDialog';

const ManagementIntraction = () => {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [selectedTeamLeads, setSelectedTeamLeads] = useState<number[]>([]);
    const [selectedTeamManagers, setSelectedTeamManagers] = useState<number[]>([]);
    const [teamList, setTeamList] = useState<any[]>([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedLeader, setSelectedLeader] = useState<any>([]);
    const [member, setMember] = useState<any[]>([]);
    const [totalCou, setTotalCou] = useState(0);
    const searchRef = useRef<HTMLInputElement>(null);
    const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });
    const [selectedEmployees, setSelectedEmployees] = useState<any[]>([]);
    const [mailLoading, setMailLoading] = useState(false);
    const [mailModalOpen, setMailModalOpen] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState<Record<string, number[]>>({});
    const mailFormRef = useRef({ subject: "", message: "" });
    const [uniqueMemberModal, setUniqueMemberModal] = useState(false);
    const [uniqueMembers, setUniqueMembers] = useState<any[]>([]);
    const [selectedUniqueMembers, setSelectedUniqueMembers] = useState<any[]>([]);
    const [search, setSearch] = useState<string>('');
    const [debouncedSearch, setDebouncedSearch] = useState<string>('');
    const [moveTeamOpen, setMoveTeamOpen] = useState(false);
    const [removeRoleOpen, setRemoveRoleOpen] = useState(false);
    const [actionLeader, setActionLeader] = useState<any>(null);
    const [query, setQuery] = useState<{ lazyParams: ILazyParams & { filters?: Record<string, any> }; filter: Record<string, (string | number)>, }>({
        lazyParams: { first: 0, rows: 20, page: 0, sortField: '', sortOrder: 1, filters: {} },
        filter: {},
    });


    const onMoveTeam = (leader: any) => { setActionLeader(leader); setMoveTeamOpen(true); };
    const onRemoveRole = (leader: any) => { setActionLeader(leader); setRemoveRoleOpen(true); };
    const handleActionDone = () => {
        setMoveTeamOpen(false);
        setRemoveRoleOpen(false);
        setActionLeader(null);
        loadTeamMembers();
    };

    const toggleUniqueMember = (row: any) => {
        const key = row.employeeId ?? row.id;
        setSelectedUniqueMembers(prev => {
            const exists = prev.some(
                x => (x.employeeId ?? x.id) === key
            );
            if (exists) {
                return prev.filter(
                    x => (x.employeeId ?? x.id) !== key
                );
            }
            return [...prev, row];
        });
    };

    async function loadTeamFilter() {
        const response = await fetchApi<IFilterOptions>('Filters/TeamFilter', 'GET', null, null, '');
        if (response) {
            setFilter(response);
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
            setQuery((prev) =>
                prev.lazyParams.first === 0
                    ? prev
                    : { ...prev, lazyParams: { ...prev.lazyParams, first: 0, page: 0 } }
            );
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [search]);

    useEffect(() => { loadTeamFilter(); }, []);

    useEffect(() => {
        loadTeamMembers();
    }, [
        query.lazyParams.first,
        query.lazyParams.rows,
        query.lazyParams.sortField,
        query.lazyParams.sortOrder,
        query.lazyParams.filters,
        debouncedSearch,
        selectedFilters,
    ]);

    const closeDrawer = () => {
        setDrawerOpen(false);
    };

    const handleSearch = (value: string) => {
        setSearch(value);
    };
    const getRowKey = (row: any) =>
        `${row.id}-${row.roleId}`;

    const toggleRow = (row: any) => {
        const key = getRowKey(row);
        setSelectedEmployees(prev => {
            const exists = prev.some(
                x => getRowKey(x) === key
            );
            if (exists) {
                return prev.filter(
                    x => getRowKey(x) !== key
                );
            }
            return [...prev, row];
        });
    };

    const toggleAll = () => {
        const allSelected =
            teamList.length > 0 &&
            teamList.every(emp =>
                selectedEmployees.some(
                    s => getRowKey(s) === getRowKey(emp)
                )
            );
        if (allSelected) {
            setSelectedEmployees([]);
        } else {
            setSelectedEmployees(teamList);
        }
    };

    async function loadTeamMembers() {
        const params = new URLSearchParams();

        params.set("first", String(query.lazyParams.first ?? 0));
        params.set("rows", String(query.lazyParams.rows ?? 20));

        if (query.lazyParams.sortField) {  params.set("sortField", query.lazyParams.sortField); }
        params.set( "sortOrder",  String(query.lazyParams.sortOrder ?? 1));
        if (debouncedSearch.trim()) { params.set("globalFilter", debouncedSearch.trim()); }

        if ( query.lazyParams.filters && Object.keys(query.lazyParams.filters).length > 0 ) {
            params.set(
                "filters",
                JSON.stringify(query.lazyParams.filters)
            );
        }

        if (Object.keys(selectedFilters).length > 0) {
            params.set("teamFilters", JSON.stringify(selectedFilters));
        }

        const response = await fetchApi(  `TeamInteraction/getTeamMemberlist?${params.toString()}`, 'GET' );
        if (response) {
            setTeamList(response.data ?? []);
            setTotalCou(response.totalCount ?? response.totalRecords ?? 0);
        }
    }

    const handleshowMember = (leader: any) => {
        setSelectedLeader(leader);
        setMember(leader.teamMembers || []);
        setDrawerOpen(true);
    };
    const openTeamMailModal = () => {
        mailFormRef.current = { subject: "", message: "" };
        setMailModalOpen(true);
    };

    const sendMailApi = async () => {
        if (selectedEmployees.length === 0) {
            addToast({
                message: "Please select Team Lead / Team Manager",
                status: "warning"
            });
            return;
        }

        if (selectedUniqueMembers.length === 0) {
            addToast({
                message: "Please select at least one Team Member",
                status: "warning"
            });
            return;
        }

        if (!mailFormRef.current.subject.trim()) {
            addToast({
                message: "Subject is required",
                status: "warning"
            });
            return;
        }

        if (!mailFormRef.current.message.trim()) {
            addToast({
                message: "Message is required",
                status: "warning"
            });
            return;
        }
        const selectedLeaders = Array.from(
            new Map(
                selectedEmployees.map(emp => [
                    emp.employeeId ?? emp.id,
                    {
                        employeeId: emp.employeeId ?? emp.id
                    }
                ])
            ).values()
        );
        const selectedMembers = Array.from(
            new Map(
                selectedUniqueMembers.map(member => [
                    member.employeeId ?? member.id,
                    {
                        employeeId: member.employeeId ?? member.id
                    }
                ])
            ).values()
        );

        const payload = {
            leaders: selectedLeaders,
            members: selectedMembers,
            subject: mailFormRef.current.subject,
            message: mailFormRef.current.message
        };

        try {
            setMailLoading(true);
            const response = await fetchApi("TeamInteraction/sendMeetingMail", "POST", payload);
            if (response) {
                addToast({ message: "Mail sent successfully", status: "success" });
                setUniqueMemberModal(false);
                setMailModalOpen(false);
                setSelectedEmployees([]);
                setSelectedUniqueMembers([]);
            }

        } finally {
            setMailLoading(false);
        }
    };

    const openUniqueMemberPreview = () => {
        if (selectedEmployees.length === 0) {
            addToast({ message: "Please select employees", status: "warning" });
            return;
        }
        if (!mailFormRef.current.subject.trim()) {
            addToast({ message: "Subject is required", status: "warning" });
            return;
        }
        if (!mailFormRef.current.message.trim()) {
            addToast({ message: "Message is required", status: "warning" });
            return;
        }
        const allMembers = selectedEmployees.flatMap(emp =>
            (emp.teamMembers || []).map((member: any) => ({
                ...member,
                tlTmName: emp.name,
                tlTmRole: emp.role
            }))
        );

        const uniqueMembers = Array.from(new Map(allMembers.map(member => [member.employeeId ?? member.id, member])).values());

        uniqueMembers.sort((a: any, b: any) => a.tlTmName.localeCompare(b.tlTmName));
        setUniqueMembers(uniqueMembers);
        setSelectedUniqueMembers(uniqueMembers);
        setUniqueMemberModal(true);
    };

    const handlecloseMail = () => {
        setSelectedUniqueMembers([]);
        setUniqueMemberModal(false);
    }

    const tableProps = { teamList, loading, selectedEmployees, toggleAll, toggleRow, getRowKey, handleshowMember, onMoveTeam, onRemoveRole, query, setQuery, totalCount: totalCou, };
    const mailModalProps = { setMailModalOpen, mailFormRef, selectedEmployees, openUniqueMemberPreview };
    const uniqueMemberModalProps = { setSelectedUniqueMembers, uniqueMembers, selectedUniqueMembers, toggleUniqueMember, mailLoading, sendMailApi };
    const drawerProps = { selectedLeader, member, reload: loadTeamMembers, setReload: () => { } };

    return (
        <MyDiv>
            <Box className="page_wrapper flex_header">
                <Flex className="page_heading" align="center" justify="space-between" w="100%">
                    <Text className="font-poppins text_3xl text_semibold" whiteSpace="nowrap"> Team Interaction</Text>

                    <Flex gap={2}>
                        <InputGroup w="230px">
                            <InputLeftElement pointerEvents="none">
                                <Search2Icon color="rgba(102, 112, 133, 1)" />
                            </InputLeftElement>
                            <Input ref={searchRef} type="text" placeholder="Search employee name" onChange={(e) => handleSearch(e.target.value)} />
                        </InputGroup>
                        <Popover placement="bottom-end" closeOnBlur >
                            <PopoverTrigger>
                                <Box cursor="pointer">
                                    <Image src={FilterIcon} alt="Filter" boxSize="40px" />
                                </Box>
                            </PopoverTrigger>
                            <FilterPopover
                                filter={filter}
                                onApplyFilter={(filters) => {
                                    const formatted: Record<string, number[]> = {};
                                    Object.keys(filters).forEach((key) => {
                                        if (filters[key].length > 0) {
                                            formatted[key.replace(" ", "")] = filters[key];
                                        }
                                    });
                                    setSelectedFilters({ ...formatted });
                                    setQuery((prev) => ({
                                        ...prev,
                                        lazyParams: {
                                            ...prev.lazyParams, page: 0, first: 0,
                                        }
                                    }));
                                }}
                            />
                        </Popover>
                        <Button colorScheme="green" isDisabled={selectedEmployees.length === 0} onClick={openTeamMailModal}> Send Mail ({selectedEmployees.length})</Button>
                    </Flex>
                </Flex>

                {/* Management Intraction List  */}
                <Grid className='grid_container'>
                    <GridItem colSpan={12} pl={4} >
                        <ManagementIntractionList {...tableProps} />
                    </GridItem>
                </Grid>
            </Box>

            {/* Management Team Drawer */}
            <Drawer isOpen={drawerOpen} placement="right" size="xl" onClose={closeDrawer} >
                <DrawerOverlay />
                <DrawerContent>
                    <ManagementTeamDrawer {...drawerProps} />
                </DrawerContent>
            </Drawer>

            {/* Management Mail Modal */}
            <Modal isOpen={mailModalOpen} onClose={() => setMailModalOpen(false)} size="5xl">
                <ModalOverlay />
                <ModalContent>
                    <ManagementMailModal {...mailModalProps} />
                </ModalContent>
            </Modal>

            {/* Management Team Members Modal */}
            <Modal isOpen={uniqueMemberModal} onClose={handlecloseMail} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ManagementTeamMembersModal {...uniqueMemberModalProps} />
                </ModalContent>
            </Modal>


            <MoveTeamModal isOpen={moveTeamOpen} onClose={() => setMoveTeamOpen(false)} leader={actionLeader} onMoved={handleActionDone} />
            <RemoveRoleDialog isOpen={removeRoleOpen} onClose={() => setRemoveRoleOpen(false)} leader={actionLeader} onRemoved={handleActionDone} />
        </MyDiv >
    );
};
export default ManagementIntraction;



